import React, { FC, useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { EmptyState } from '../empty_state/EmptyState';
import { FILTER_CONFIG_NAMES } from '../../utils/DataConstants';
import {
	fetchLocationsWithBuyerCompaniesForSupplier,
	locationsRestCrudThunksForSupplier,
} from '../../thunks/locations_thunks';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';
import ProblemTypeTreeSelect from '../problem_type_tree_select';
import { BIDDERS_CRUD_ACTION_CREATORS } from '../../actions/bidders_actions';
import { biddersRestCrudThunksForSupplier, refreshBiddersCount } from '../../thunks/bidders_thunks';
import PaginatedReduxTableWithHeader from '../common/PaginatedReduxTableWithHeader';
import BiddersPipelineFilters from './BiddersPipelineFilters';
import BidderRowDisplay from './BidderRowDisplay';

const BIDDERS_TARGET_COLLECTION = 'biddersIndex';
const BIDDERS_ADVANCED_FILTERS = 'biddersAdvancedFilters';

const OppurtunitiesIndexPage: FC<any> = ({
	history,
	updateFilters,
	bidders,
	clearAndUpdateFilters,

	userType,
	locations,
	fetchMultipleLocations,
	currentUser,
	refreshCounts,
	location,
	fetchLocationsWithBuyerCompanies,
}) => {
	const columns = [
		{
			title: 'Name',
			dataIndex: 'title',
			render: (text, record) => <BidderRowDisplay bidder={record} />,
		},
	];

	const onRow = (record) => ({
		onClick: () =>
			history.push(
				getLinkWIthBackLinkParams(
					location,
					'',
					`/${userType}/opportunities/detail/${record.requestForProposalId}`
				)
			),
	});

	const filterConfig = useMemo(
		() => [
			{
				label: 'Location',
				fieldName: FILTER_CONFIG_NAMES.LOCATION,
				mode: 'multiple',
				stateSlice: locations,
				targetCollectionName: BIDDERS_ADVANCED_FILTERS,
				fetch: fetchLocationsWithBuyerCompanies,
				fetchMultiple: fetchMultipleLocations,
				component: ProblemTypeTreeSelect,
			},
		],
		[fetchLocationsWithBuyerCompanies, fetchMultipleLocations, locations]
	);

	return (
		<PaginatedReduxTableWithHeader
			targetCollectionName={BIDDERS_TARGET_COLLECTION}
			updateFilters={updateFilters}
			stateSlice={bidders}
			clearAndUpdateFilters={clearAndUpdateFilters}
			refreshCounts={refreshCounts}
			pipeLineFilters={BiddersPipelineFilters}
			filterConfig={filterConfig}
			entityCollectionName="bidders"
			tableColumns={columns}
			onTableRow={onRow}
			initialPagination={{ current: 1, pageSize: 10 }}
			fetchData={biddersRestCrudThunksForSupplier.read}
			handleQueryParams
			emptyState={
				<EmptyState
					graphic={
						<img
							style={{ marginBottom: 8 }}
							src="https://s3.amazonaws.com/mock-data-assets/categories/images/letter owl.svg"
							alt={`There are no oppurtunities for you!`}
						/>
					}
					headline={`There are no oppurtunities for you!`}
					body={null}
				/>
			}
		/>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
	bidders: state.bidders,
	locations: state.locations,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	updateFilters: (filters, targetCollection) =>
		dispatch(BIDDERS_CRUD_ACTION_CREATORS.updateFilters(filters, targetCollection)),
	clearAndUpdateFilters: (filters, targetCollectionName) =>
		dispatch(BIDDERS_CRUD_ACTION_CREATORS.clearAndUpdateFilters(filters, targetCollectionName)),
	fetchMultipleLocations: (ids, targetCollectionName) =>
		dispatch(locationsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchLocationsWithBuyerCompanies: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			fetchLocationsWithBuyerCompaniesForSupplier(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	refreshCounts: (filters) => dispatch(refreshBiddersCount(ownProps.userType)(filters)),
});

const ComponentWithoutUserType = withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(OppurtunitiesIndexPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
